import { useEffect, useState } from "react";
import TimezonePicker from "../../components/common/TimezonePicker";

const TimeZoneModal = ({ meeting, timezone, onSave }) => {
  const [selectedTimezone, setSelectedTimezone] = useState(
    Intl.DateTimeFormat().resolvedOptions().timeZone,
  );

  useEffect(() => {
    setSelectedTimezone(
      meeting?.timezone ||
        timezone ||
        Intl.DateTimeFormat().resolvedOptions().timeZone,
    );
  }, [meeting?.timezone, timezone]);

  const handleSubmit = () => {
    const value =
      typeof selectedTimezone === "string"
        ? selectedTimezone
        : selectedTimezone.value;

    onSave?.(value);
  };

  return (
    <div
      className="modal fade"
      id="meetingTimezoneModal"
      tabIndex="-1"
      aria-labelledby="meetingTimezoneModalLabel"
    >
      <div
        className="modal-dialog modal-dialog-centered"
        style={{ maxWidth: "600px" }}
      >
        <div className="modal-content border-0 shadow-lg">
          <div className="modal-header position-relative">
            <h5 className="fw-semibold mb-0" id="meetingTimezoneModalLabel">
              Meeting Timezone
            </h5>

            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              style={{
                position: "absolute",
                right: "20px",
                top: "70%",
                transform: "translateY(-50%)",
                zIndex: 10,
              }}
            />
          </div>

          <div className="modal-body">
            <TimezonePicker
              value={selectedTimezone}
              onChange={setSelectedTimezone}
            />
          </div>

          <div className="modal-footer d-flex justify-content-between">
            <button
              type="button"
              className="btn btn-outline-secondary btn-sm"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>

            <button
              type="button"
              className="btn btn-primary btn-sm"
              onClick={handleSubmit}
            >
              Save Timezone
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TimeZoneModal;
